import React from "react";
import { ArrowUpRight } from "lucide-react";
import { insights } from "../mock";

const Journal = () => {
  return (
    <section id="insights" className="relative py-28 md:py-36 overflow-hidden">
      <div className="cosmic-bg absolute inset-0" />
      <div className="stars" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="divider-star"><span>Field Notes</span></div>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] mt-6 text-[#EDE3D0] max-w-2xl">
              Insights from the healing chair
              <span className="italic text-[#D4A85B]"> & the altar.</span>
            </h2>
          </div>
          <a href="#contact" className="text-xs uppercase tracking-[0.28em] text-[#D4A85B] hover:text-[#E9C77B]">
            Sunday love-letters →
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {insights.map((post, i) => (
            <a
              key={post.id}
              href="#insights"
              className={`group relative rounded-3xl overflow-hidden border border-[#D4A85B]/25 bg-[#12081E]/70 hover:border-[#D4A85B]/70 transition ${
                i === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? "h-[380px]" : "h-[220px]"}`}>
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#12081E] via-[#12081E]/20 to-transparent" />
                <span className="absolute top-4 left-4 bg-[#0A0714]/80 backdrop-blur border border-[#D4A85B]/30 text-[#D4A85B] text-[10px] uppercase tracking-[0.28em] rounded-full px-3 py-1.5">
                  {post.category}
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.28em] text-[#D4A85B]/80">
                  <span>{post.date}</span>
                  <span>·</span>
                  <span>{post.readTime}</span>
                </div>
                <h3 className={`font-serif mt-3 text-[#EDE3D0] leading-tight ${i === 0 ? "text-3xl md:text-4xl" : "text-xl"}`}>
                  {post.title}
                </h3>
                <p className="mt-3 text-sm text-[#EDE3D0]/70 leading-relaxed line-clamp-3">{post.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.24em] text-[#D4A85B] group-hover:gap-2.5 transition-all">
                  Read note <ArrowUpRight size={13} />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journal;
